import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { NativeProps } from '@/src/components/interfaces';

export interface CLinkProps extends NativeProps {
  href?: string;
}

export function CLink(props: PropsWithChildren<CLinkProps>): React.JSX.Element {
  return (
    <a
      href={props.href}
      onClick={props.onClick}
      id={props.id}
      data-test-selector={props.testSelector}
      className={classNames('c-link', 'cursor--pointer', 'tap--disabled', props.class, 'no-select')}
    >
      {props.children}
    </a>
  );
}